import { combineReducers } from "redux"
import TenantReducer from "./TenantReducer"
import TenantUserReducer from "./TenantUserReducer"

export default combineReducers({
	tenant: TenantReducer,
	tenantUser: TenantUserReducer,
})
